export default __webpack_public_path__ + "static/maxxbw2-0e136188cc5c312f3c35fbc091fa5c24.png";